export const BlockLink = ({
	children,
	value,
	onClick,
}: {
	children: React.ReactNode;
	value?: unknown;
	onClick?: (href?: string) => void;
}) => {
	const href =
		value &&
		typeof value === 'object' &&
		'href' in value &&
		typeof (value as { href?: unknown }).href === 'string'
			? (value as { href: string }).href
			: undefined;

	// Чтобы не передавать пропс-функцию без надобности. Иначе придется компоненту клиентской делать
	// А так это на совести потребителя
	const props = {
		...{ onClick: onClick ? () => onClick(href) : undefined },
	};

	return href ? (
		<a target="_blank" rel="noopener noreferrer" href={href} {...props}>
			{children}
		</a>
	) : (
		children
	);
};
